// Web feature flags. Mirrors the mobile app's src/lib/featureFlags.js in purpose:
// one place to switch a surface off without deleting the code behind it.

// Supplier-facing referral/rewards surfaces: the "$60 per supplier you invite"
// card on the dashboard home, the Wallet & Referrals tab, the locked wallet
// teaser, and the referral-code field on the supplier signup form.
//
// Switched OFF on 2026-09-16 at the owner's direction — "ما فيه أي نتيجة",
// hide it now and decide its future later. HIDDEN, NOT DELETED, deliberately:
//   · the referrals / referral_rewards tables keep their rows
//   · the admin page (/admin/referrals) is untouched and still reads them
//   · pending_referral_code is still written at signup, so a ?ref= link that is
//     already in circulation still attributes correctly if this is turned back on
// Bringing the programme back is this one line, not a rebuild.
export const SHOW_SUPPLIER_REFERRALS = false;

// Social-media links in the site footer: the "تابعنا / Follow us" column with
// the Instagram, Snapchat and TikTok marks.
//
// ON again since 2026-10-15 at the owner's direction («بالفوتر فيه حسابات
// التواصل اظهرها في الويب والتطبيق»). It was hidden 2026-09-20 to 2026-10-15.
// The app mirrors the same three links in src/lib/socialLinks.js (guest home
// footer + Contact screen), so a change to a URL here needs the same change
// there.
//
// With the flag on, Footer.jsx adds `has-social` to the column grid, which
// widens it from three tracks (brand, company, seal) to four. Setting this back
// to false returns the three-track footer with no other edit.
export const SHOW_SOCIAL_LINKS = true;

// HioBuy phase 2 — the market catalog preview (/market, /market/:id).
//
// LOCAL ONLY (owner, 2026-10-19): «I want to open localhost and see how the
// imported products will look to a MAABAR trader» — before any customer-facing
// deployment. The routes exist only when the build is started with
// REACT_APP_MARKET_PREVIEW=1 (put it in .env.local, which git ignores). It must
// never be set in Vercel — that is a rule, not a fact checked from here (the
// Vercel env is not readable from this repo). The tables these pages read are
// admin-read-only in RLS, so even a build with the flag shows a customer nothing.
export const MARKET_PREVIEW = process.env.REACT_APP_MARKET_PREVIEW === '1';

// Search by photo across MAABAR's suppliers (market-source-search: HioBuy's
// own photo search, owner decision 2026-10-20). ON in production through
// .env.production; the local stack mocks the HioBuy side. Without the flag
// there is no camera button. (The earlier catalog-only market-image-search,
// which needed an embedding provider, is no longer what the page calls.)
export const IMAGE_SEARCH = MARKET_PREVIEW && process.env.REACT_APP_IMAGE_SEARCH === '1';
